<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <el-form ref="queryForm" :model="queryParams" :inline="true" class="search-form clearfix">
      <el-form-item class="search-field fl" label="操作员用户名" prop="operateName">
        <el-input v-model.trim="queryParams.operateName" placeholder="请输入操作员用户名" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl" label="请求URL" prop="apiUrl">
        <el-input v-model.trim="queryParams.apiUrl" placeholder="请输入请求URL" clearable
          @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl" label="请求方式" prop="requestMethod">
        <el-select-dict dictType="REQUEST_METHOD" v-model="queryParams.requestMethod" placeholder="请选择请求方式" clearable
          @dictChange="handleQuery" />
      </el-form-item>
      <el-form-item class="search-field fl" label="渠道" prop="operateChannel">
        <el-select-dict dictType="CHANNEL" clearable placeholder="请选择渠道" v-model="queryParams.operateChannel"
          @change="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl" label="状态" prop="status">
        <el-select-dict dictType="SUCCESS_FAIL" clearable placeholder="请选择状态" v-model="queryParams.status"
          @change="handleQuery"></el-select-dict>
      </el-form-item>
      <el-form-item class="search-field fl" label="操作时间" prop="beginTime">
        <el-date-picker v-model="dateRange" value-format="yyyy-MM-dd HH:mm:ss" type="daterange" @change="handleQuery"
          range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
      </el-form-item>

      <el-form-item class="fr">
        <el-button plain @click="resetQuery">重 置</el-button>
        <el-button type="primary" @click="handleQuery">查 询</el-button>
      </el-form-item>
    </el-form>
    <div class="table-wrap">
      <div class="table-control-box">
        <el-button v-hasPermi="['log:operate:delete']" type="danger" plain icon="el-icon-delete" size="mini"
          :disabled="multiple" @click="handleBatchDelete">删除</el-button>

        <el-button v-hasPermi="['log:operate:deleteAll']" class="fr" type="danger" icon="el-icon-delete"
          size="mini" @click="handleDeleteAll">全部删除</el-button>
      </div>
      <div class="table-box">
        <auto-height-table ref="operateLogTable" :class="{ 'empty': list.length === 0 }" empty-text=" "
          v-loading="loading" :data="list" row-key="logId" @selection-change="handleSelectionChange" @row-click="clickRow">
          <el-table-column type="selection" :reserve-selection="true" width="55" align="center" />
          <el-table-column label="操作员用户名" prop="operater.userName" align="center" min-width="200px" />
          <el-table-column label="请求URL" prop="apiUrl" align="center" min-width="300px" show-overflow-tooltip />
          <el-table-column label="请求方式" prop="requestMethod" align="center" min-width="200px" />
          <el-table-column-dict dictType="CHANNEL" dictTypeNode="tag" label="渠道" align="center" prop="operateChannel"
            min-width="100px"></el-table-column-dict>
          <el-table-column-dict dictType="SUCCESS_FAIL" dictTypeNode="tag" label="状态" align="center" prop="status"
            min-width="100px"></el-table-column-dict>
          <el-table-column-dict dateFormat="datetime" label="操作日期" align="center" prop="operateTime"
            min-width="168px"></el-table-column-dict>
          <el-table-column v-if="
            hasPermi([
              'log:operate:read',
            ])
          " label="操作" align="center" width="128px" fixed="right" class-name="small-padding ">
            <template slot-scope="scope">
              <el-button v-hasPermi="['log:operate:read']" size="mini" type="primary" icon="el-icon-view"
                @click.native.stop="getDetail(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </auto-height-table>

        <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize" @pagination="getList" />
      </div>
    </div>

    <operate-log-dialog ref="operateLogDialog" title="日志详情" width="996px" :visible.sync="open"
      :modal-append-to-body="false" :close-on-click-modal="false" :baseForm="baseForm"
      @close="open = false"></operate-log-dialog>
  </div>
</template>

<script>
import { logApi } from "@/api"
import OperateLogDialog from "./components/operate-log-dialog.vue"
export default {
  name: "logOperateManage",
  components: {
    OperateLogDialog
  },
  data() {
    return {
      //搜索条件参数
      queryParams: {
        operateName: "", // 操作员用户名
        requestMethod: "", // 请求方式
        apiUrl: "", // 接口请求地址
        operateChannel: "", // 操作渠道
        status: "", // 操作状态
        beginTime: "",
        endTime: "",
        pageNum: 1,
        pageSize: 10
      },
      dateRange: [],
      list: [],
      loading: false,
      total: 0,
      open: false,

      // 非多个禁用(0个禁用)
      multiple: true,
      selection: [], // 选中的列表数据
      
      // 表单参数
      baseForm: {
        operateName: "", // 操作员用户id
        operateIp: "", // 操作IP地址
        apiUrl: "", // 接口请求地址
        requestMethod: "", // 请求方式
        status: "", // 请求状态
        operateMsg: "", // 请求提示语
        operateTime: "", // 操作时间
        responseTime: "", // 接口响应时间
        operateLocationCountry: "", // 操作地址(国家)
        operateLocationCity: "", // 操作地址(城市)
        operateLocationRegion: "", // 操作地址(区域)
        operateLocationLatitude: "", // 操作地址(经度)
        operateLocationLongitude: "", // 操作地址(纬度)
        browser: "", // 操作设备信息
        queryJson: "", // 请求入参
        bodyJson: "" // 请求入参
      }
    }
  },
  created() {
    //获取列表
    this.getList()
  },
  methods: {
    // 删除全部登录日志
    handleDeleteAll() {
      // 让按钮返回原样
      this.btnBlur()

      this.$modal
        .confirm("删除后不可找回，是否确认删除全部操作日志？")
        .then(function() {
          return logApi.deleteAllOperateLog()
        })
        .then(() => {
          this.handleQuery()
          this.$modal.msgSuccess("删除全部操作日志成功")
        })
        .catch(() => { })
    },
    //批量删除
    handleBatchDelete() {
      // 让按钮返回原样
      this.btnBlur()

      const ids = []
      for (let i = 0; i < this.selection.length; i++) {
        const item = this.selection[i]
        ids.push(item.logId)
      }

      this.$modal
        .confirm("删除后不可找回，是否确认删除已选择的数据项？")
        .then(function() {
          return logApi.batchDeleteOperateLog({ ids })
        })
        .then(() => {
          this.handleQuery()
          this.$modal.msgSuccess("批量删除登录日志成功")
        })
        .catch(() => { })
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selection = selection
      this.multiple = !selection.length
    },
    //点击行
    clickRow(row) {
      this.$refs.operateLogTable.toggleRowSelection(row)
    },
    /** 搜索按钮操作 */
    handleQuery() {
      // 清空已选项
      this.$refs.operateLogTable.clearSelection()

      this.queryParams.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dateRange = []
      this.resetForm("queryForm")
      this.handleQuery()
    },
    /** 查询操作日志列表 */
    getList() {
      this.loading = true
      logApi
        .getOperateLogList(this.addDateRange(this.queryParams, this.dateRange))
        .then((response) => {
          this.list = response.rows
          this.total = response.total
          this.loading = false
        })
        .catch((err) => {
          if (err?.name === "CanceledError") {
            return
          }
          this.loading = false
        })
    },
    /** 查看详情 */
    getDetail(row) {
      const id = row.logId
      logApi.getOperateLogDetailById({ id }).then((data) => {
        this.baseForm = Object.assign(this.baseForm, data)
        this.open = true
      })
    }
  }
}
</script>
